import styled from 'styled-components';

export const VestingAllocationLegendStyles = styled.div`
	display: flex;
	align-items: center;
	gap: 0.25rem;

	.indicator {
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
	}
`;
